<template>
  <div class="content-process">
    <van-steps :active="active">
      <van-step>选择类型</van-step>
      <van-step>查询会员码</van-step>
      <van-step>验证信息与核销</van-step>
      <van-step>完成</van-step>
    </van-steps>
  </div>
</template>
<script>
export default {
  props: {
    active: Number
  },
  data() {
    return {};
  }
};
</script>